import { SvgIcon, TooltipComponent, theme } from '@salecycle/ui-component-library';
import styled from 'styled-components';
import { TriggerEventCard } from './TriggerEventCard';
import { useTranslation } from 'react-i18next';
import { SchedulingControl } from 'sections/onsite-campaigns/pages/CampaignEditor/tabs/CampaignSettingsTab/components/SchedulingControl';

const Container = styled.div`
  display: relative;
`;

const Header = styled.div`
  display: flex;
  position: relative;
  margin-bottom: ${({ theme }) => theme.designToken.spacing3};
  > div > div {
    position: fixed;
    top: 108px;
    left: 330px;
  }
`;

const Title = styled.div`
  font: ${({ theme }) => theme.designToken.body1Semibold};
`;

export const TriggerEvent = () => {
  const { t } = useTranslation('campaigns');

  return (
    <Container>
      <Header>
        <Title>{t('onsite.editor.workflow.triggerMessage.triggerEvent.title')}</Title>
        <TooltipComponent
          id="tooltip"
          title={t('onsite.editor.workflow.triggerMessage.triggerEvent.toolTipTitle')}
          label={t('onsite.editor.workflow.triggerMessage.triggerEvent.toolTipLabel')}
          position="Right"
        >
          <span style={{ display: 'block', margin: '2px 0px 0px 4px' }}>
            <SvgIcon name="circle-question" size="16" color={theme.designToken.primary700} />
          </span>
        </TooltipComponent>
      </Header>

      <TriggerEventCard
        icon="browser"
        title={t('onsite.editor.workflow.triggerMessage.triggerEvent.triggerEventCardTitle')}
        description={t('onsite.editor.workflow.triggerMessage.triggerEvent.triggerEventCardDesc')}
      />

      <SchedulingControl />
    </Container>
  );
};
